import { catcher } from "./masterApi";
import { setLoaderApp, setLoaderProgress } from "store/loader/loaderSlice";
import * as R from "ramda";
import { getStore } from "store/storeAccessor";
import { isBlob } from "react-pdf/dist/umd/shared/utils";
import { toast } from "react-toastify";

const setLoading = setLoaderApp;

let requestCount = 0; // Keep track of the ongoing API requests
let hasShownNetworkError = false;

let interval = null;
const clientLoader = async (method, link, data, config) => {
  const dispatch = getStore().dispatch;

  try {
    if (requestCount === 0) {
      let progress = 0;
      dispatch(setLoading(true)); // Set loading to true only if no ongoing requests
      dispatch(setLoaderProgress(progress));
      interval = setInterval(() => {
        progress += 5;
        if (progress > 95) {
          clearInterval(interval);
          progress = 90;
        }
        dispatch(setLoaderProgress(progress));
      }, 100);
    }
    requestCount++;

    const res = await catcher(method, link, data, config);
    requestCount--;
    if (requestCount === 0) {
      clearInterval(interval);
      dispatch(setLoaderProgress(100));
      setTimeout(() => {
        dispatch(setLoading(false));
      }, 1000);
    }
    if (res.error) {
      if (res.error === "Network Error" && !hasShownNetworkError) {
        toast.error("Network Error. Please check your internet connection.");
        hasShownNetworkError = true;
        // Reset after a few seconds so the toast can be shown again later if needed
        setTimeout(() => {
          hasShownNetworkError = false;
        }, 5000);
      }
      //toast.error(res.message);
    }
    return isBlob(res) ? res : { ...res };
  } catch (error) {
    requestCount--;
    if (requestCount === 0) {
      dispatch(setLoading(false)); // Set loading to false if all requests are completed
      dispatch(setLoaderProgress(0));
      clearInterval(interval);
    }
  }
};
const clientNoLoaderCathcer = async (method, link, data, params) => {
  try {
    const res = await catcher(method, link, data, params);
    return isBlob(res) ? res : { ...res };
  } catch (error) {
    return error;
  }
};

export const clientNoLoader = R.curryN(4, clientNoLoaderCathcer);

export const loaderWithSetter = (setter) =>
  R.curryN(4, async (method, link, data, params) => {
    // debugger;
    setter(true);
    const res = await catcher(method, link, data, params);
    setter(false);
    // debugger;
    return { ...res };
  });
/* -------------------------------------------------------------------------- */
const loaderClient = R.curryN(4, clientLoader);
export default loaderClient;
